module.exports = __webpack_public_path__ + "static/media/i35.f3aa554f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i35.svg
// module id = 347
// module chunks = 8